import React, { useContext } from 'react';
import { Card, notification, Form, Button } from 'antd';
import { useApolloClient } from "@apollo/react-hooks";
import CommentsList from '../../Pages/Lists/Comments';
import { AppContext } from 'utils/AppContext';
//@ts-ignore
import FormBuilder from 'antd-form-builder';
import { FormComponentProps } from "antd/lib/form";
import { CREATE_COMMENT } from './commentsQueries';

const FORM_META = {
  fields: [
    { key: 'message', label: 'Message', widget: 'input', required: true, colSpan: 2 },
  ],
}

type Props = {
  conditions: any
}

type FormProps = { entity: string, entityName: string, userId: string } & FormComponentProps

const CreateNewCommentForm = Form.create<FormProps>()((props: FormProps) => {
  const { entity, userId, entityName } = props;
  const client = useApolloClient();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.form.validateFields(async (err: any, values: any) => {
      if (err) console.error(err);
      await client.mutate({
        mutation: CREATE_COMMENT,
        variables: {
          data: {
            entity,
            entityName,
            user: userId,
            ...values,
          }
        },
      });
      props.form.resetFields();

      notification.open({
        message: 'Comment has been created',
      });
    });
  };

  return (
    <Form onSubmit={handleSubmit} layout="vertical">
      <FormBuilder meta={FORM_META} form={props.form} />
      <Form.Item>
        <Button
          style={{ float: 'right' }}
          htmlType="submit"
          type="primary"
          disabled={(props.form.getFieldValue('message') || '').length === 0}
        >
          Create comment
        </Button>
      </Form.Item>
    </Form>
  )
})

const Comments = (props: Props) => {
  const { conditions } = props;
  const { user } = useContext(AppContext);

  return (
    <Card title={'Comments'} bordered={false}>
      <CreateNewCommentForm entityName={conditions.entityName} entity={conditions.entity} userId={(user || { id: 'error' }).id} />
      <CommentsList
        conditions={conditions}
        createTab={() => { }}
        tableOptions={{ hideExtraRow: true, hideTitle: true }}
      />
    </Card>
  )
}

export default Comments;
